import React, { memo } from "react";
import SettingCardSkeleton from "./SettingCardSkeleton";

const ComposingPreferencesSkeleton = memo(() => {
  return (
    <div className="grid grid-cols-1 gap-5 lg:gap-7.5 mb-[20px]">
      <SettingCardSkeleton
        titleWidth={110}
        controls={["input", "input", "input", "input", "input", "switch", "switch", "switch", "input", "input"]}
        showFooter
      />
    </div>
  );
});

ComposingPreferencesSkeleton.displayName = "ComposingPreferencesSkeleton";

export default ComposingPreferencesSkeleton;
